const csvHelper = function () {
    "use strict";

    function exportOnIE(data, filename) {
        // Create a CSV Blob
        const blob = new Blob([data], { type: "text/csv" });

        // Determine which approach to take for the download
        if (navigator.msSaveOrOpenBlob) {
            // Works for Internet Explorer and Microsoft Edge
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            // Attempt to use an alternative method
            const anchor = document.body.appendChild(
                document.createElement("a")
            );

            // If the [download] attribute is supported, try to use it
            if ("download" in anchor) {
                anchor.download = filename;
                anchor.href = URL.createObjectURL(blob);
                anchor.click();
            }
        }
    }

    function msieversion() {
        const ua = window.navigator.userAgent;

        // Test values; Uncomment to check result …

        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

        // Edge 12 (Spartan)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

        // Edge 13
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

        const msie = ua.indexOf("MSIE ");
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
        }

        const trident = ua.indexOf("Trident/");
        if (trident > 0) {
            // IE 11 => return version number
            const rv = ua.indexOf("rv:");
            return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
        }

        const edge = ua.indexOf("Edge/");
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
        }

        // other browser
        return false;
    }

    function convertArrayOfObjectsToCSV(args) {
        let ctr;
        const data = args.data || null;

        if (data == null || !data.length) {
            return null;
        }

        let result = "";
        let keys = Object.keys(data[0]);
        const columnDelimiter = args.columnDelimiter || `","`;
        const lineDelimiter = args.lineDelimiter || `"\n"`;

        result += keys.join(columnDelimiter);
        result += lineDelimiter;
        let row = 0;

        _.forEach((data), function (item) {
            ctr = 0;
            _.forEach(keys, function (key) {
                if (ctr > 0) {
                    result += columnDelimiter;
                }

                // Determine if a certain key holds an array value
                if (_.isArray(item[key])) {

                    // Lets determine the column where we align the data
                    // that it holds
                    const index = keys.indexOf(key);
                    const columnDelimiterTab = _.times(index, () => `","`);

                    result += item[key].join(lineDelimiter + columnDelimiterTab.join(""));
                } else {
                    result += item[key];
                }

                ctr += 1;
            });
            ++row;

            if (row !== data.length) {
                result += lineDelimiter;
            } else {
                result += '"';
            }
        });

        return `"` + result;
    }

    function downloadCSV(data, args) {
        let filename, link, output, outputStr;
        const csv = convertArrayOfObjectsToCSV({
            data: data
        });

        output = args.add || [];
        output.push(csv);
        outputStr = output.join("\n");

        if (outputStr == null) {
            toastr.info("No data to export");
            return;
        }

        filename = args.filename || "export.csv";

        //export csv for IE
        //Other Browsers
        if (msieversion()) {
            exportOnIE(outputStr, filename);
        } else {
            let link = document.createElement("a");
            const blob = new Blob([outputStr], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);

            link = document.createElement("a");
            link.setAttribute("href", url);
            link.setAttribute("download", filename);

            // Required for FF
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    return { downloadCSV, msieversion };
};

export default csvHelper;
